import configs from "../../configs";
import actions from "./actions";
import mutations from "./mutations";
import {Hotel} from "@/models/Hotel";
import getters from "@/store/app/getters";
const { product, time, theme, currencies  } = configs;
const { globalTheme, menuTheme, toolbarTheme, isToolbarDetached, isContentBoxed, isRTL } = theme;
const { currency, availableCurrencies } = currencies;
const hotel:Hotel=new Hotel();
const hotels:any[]=[];
const user:any={};
const local:any={};
const state = {
  isOffline:false,
  isSyncing:false,
  product,
  hotels,
  time:"YYYY-MM-DD HH:mm:ss",
  currency,
  availableCurrencies,
  globalTheme,
  menuTheme,
  toolbarTheme,
  local,
  info: {
    type:"error",
    title:"",
    body:{} || "",
    visible: false,
    textColor: "#E81123",
    icon:"",
  },
  isToolbarDetached,
  isContentBoxed,
  isRTL,
  hotel,
  user,
  toast: {
    show: false,
    message: "",
    timeout: 3000,
  },
  archConfirm:{
    icons:{
      "info": {
        icon: "fas fa-info-circle",
        color: "rgb(97 90 90)"
      },
      "warning": {
        icon: "fas fa-exclamation-circle",
        color: "rgb(232 186 44)"
      },
      "success": {
        icon:"mdi-check",
        color:"#366436"
      },
    },
    type:"info",
    title:null,
    message:"message",
    yes:"Ok",
    no:"No",
    show: false,
    closing: false,
    onYesCallback:null,
    onNoCallback:null
  },
  window:{
    width:-1,
    height:-1,
  },
  archSelectOptions: []
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
